import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Modal } from "react-bootstrap";
import consentFi from "../locales/consent.fi.json";
import consentEn from "../locales/consent.en.json";
import consentSe from "../locales/consent.se.json";
import consentNo from "../locales/consent.no.json";
import useI18n from "../hooks/useI18n";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { far } from "@fortawesome/pro-regular-svg-icons";

const consents = {
    fi: consentFi,
    en: consentEn,
    se: consentSe,
    no: consentNo
}

const SignUpConsentModal = (props) => {
    const [expanded, setExpanded] = useState(false);
    const { getLocale } = useI18n();
    const consent = consents[getLocale() ?? 'fi'];

    const handleCancel = () => {
        props.onCancel();
    }

    const handleConfirm = () => {
        props.onConfirm();
    }

    const handleExpand = () => {
        setExpanded(!expanded);
    }

    const chevronElement = expanded
        ? (<FontAwesomeIcon icon={far.faChevronUp} />)
        : (<FontAwesomeIcon icon={far.faChevronDown} />);

    return (
        <Modal show={props.show} id='sign-up-consent-modal'>
            <Modal.Header>
                <Modal.Title>{consent.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>{consent.subtitle}</p>
                <Button
                    onClick={handleExpand}
                    className='btn-toggle-terms'
                >
                    {consent.termsButton}
                    {chevronElement}
                </Button>
                {expanded && <div className="mt-3" dangerouslySetInnerHTML={{ __html: consent.content.join('\n') }} />}
                <div className="d-flex gap-2 mt-4">
                    <Button variant='secondary' onClick={handleCancel} className='flex-fill'>
                        {consent.declineButton}
                    </Button>
                    <Button variant='primary' onClick={handleConfirm} className='flex-fill'>
                        {consent.acceptButton}
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

SignUpConsentModal.propTypes = {
    show: PropTypes.bool,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func
};

export default SignUpConsentModal;
